export const paginationInitialState = {
  limit: 30,
  offset: 0,
  count: 0
}

export const filterInitialState = {
  fullName: null,
  iin: null,
  loanApplicationId: null,
  creditProductCode: null,
  statusCode: null,
  mobilePhone: null,
  manager: null,
  collateralId: null,
  marketValueFrom: null,
  marketValueTo: null,
  collateralValueFrom: null,
  collateralValueTo: null,
  bankBin: null
}

export const initialNewLoanApplication = {
  id: null,
  creditProduct: null,
  loanAmount: null,
  currency: null,
  disbursementMethod: null,
  loanPurpose: null,
  paymentIntervalDays: null,
  numberOfTranches: null,
  interestRate: null,
  loanType: null,
  loanStage: null
}

export const initLoanApplicationData = {
  id: null,
  applicationCode: null,
  creditProduct: null,
  loanAmount: null,
  currency: null,
  disbursementMethod: null,
  loanPurpose: null,
  paymentIntervalDays: null,
  numberOfTranches: null,
  interestRate: null,
  loanType: null,
  loanStage: null,
  debtBurdenRatio: null,
  clientId: null,
  clientFullName: null,
  createdDate: null,
  status: {
    code: null,
    name: null
  },
  client: {
    id: null,
    firstName: null,
    lastName: null,
    patronymic: null,
    birthDate: null,
    birthPlace: null,
    citizenship: null,
    documentType: null,
    iin: null,
    resident: null,
    documentNumber: null,
    documentIssuer: null,
    documentIssueDate: null,
    documentExpiryDate: null,
    maritalStatus: null,
    numberOfDependents: null,
    education: null,
    clientType: null,
    sexName: null,
    activityType: null,
    organizationName: null,
    position: null,
    jobLevel: null,
    monthlyIncome: null,
    employmentDuration: null,
    totalExperience: null,
    workPhone: null,
    pensionAmount: null,
    additionalIncomeSource: null,
    additionalIncomeAmount: null,
    country: null,
    address: null,
    region: null,
    district: null,
    ruralArea: null,
    settlement: null,
    street: null,
    neighborhood: null,
    houseNumber: null,
    apartment: null,
    kzAddress: null,
    residenceAddress: null,
    mobilePhone1: null,
    mobilePhone2: null,
    email: null,
    relatives: [
      {
        fullName: null,
        relationship: null,
        phone: null,
        workPlace: null
      },
      {
        fullName: null,
        relationship: null,
        phone: null,
        workPlace: null
      },
      {
        fullName: null,
        relationship: null,
        phone: null,
        workPlace: null
      }
    ],
    loanCount: null,
    loanMonthlyPaymentsAmount: null,
    loanDelinquencies: null
  },
  collaterals: []
}
